export var LicenseType;
(function (LicenseType) {
    LicenseType["FREEMIUM"] = "FREEMIUM";
    LicenseType["CONTACT_CENTER"] = "CONTACT_CENTER";
    LicenseType["CONTACT_CENTER_FOR_SUPPORT"] = "CONTACT_CENTER_FOR_SUPPORT";
    LicenseType["CONTACT_CENTER_FOR_SUPPORT_TRIAL"] = "CONTACT_CENTER_FOR_SUPPORT_TRIAL";
    LicenseType["GOTO_CONTACT_CORE"] = "GOTO_CONTACT_CORE";
    LicenseType["REVENUE_CENTER"] = "CONTACT_CENTER_REVENUE_CENTER";
    LicenseType["CONTACT_CENTER_REVENUE_CENTER_TRIAL"] = "CONTACT_CENTER_REVENUE_CENTER_TRIAL";
})(LicenseType || (LicenseType = {}));
export const createTierLabelsMap = ({ useGoToContactLabels, isQueueManagerEnabled, } = {}) => ({
    [LicenseType.FREEMIUM]: 'Freemium',
    [LicenseType.CONTACT_CENTER]: isQueueManagerEnabled
        ? 'Insights Center - Promotional access to Complete features'
        : 'Insights Center',
    [LicenseType.CONTACT_CENTER_FOR_SUPPORT]: 'Support Center',
    [LicenseType.CONTACT_CENTER_FOR_SUPPORT_TRIAL]: 'Support Center 60-Day Trial',
    [LicenseType.CONTACT_CENTER_REVENUE_CENTER_TRIAL]: 'GoTo Contact Complete Trial',
    [LicenseType.REVENUE_CENTER]: useGoToContactLabels ? 'GoTo Contact Complete' : 'Revenue Center',
    [LicenseType.GOTO_CONTACT_CORE]: 'GoTo Contact Core',
});
export var CCPermissions;
(function (CCPermissions) {
    CCPermissions["CALL_CAMPAIGNS_VIEW"] = "cc-config.call-campaigns";
    CCPermissions["CALL_QUEUES_VIEW"] = "cc-config.call-queues";
    CCPermissions["CCA_CHAT_QUEUES_VIEW"] = "cc-agent.chat-queues";
    CCPermissions["CCA_PAGE_VIEW"] = "cc-agent";
    CCPermissions["CHAT_QUEUES_VIEW"] = "cc-config.chat-queues";
    CCPermissions["CONTACT_CENTER_CONFIGURATION_PAGE_VIEW"] = "cc-config";
    CCPermissions["GENERAL_SETTINGS_VIEW"] = "cc-config.settings";
    CCPermissions["OVERVIEW_VIEW"] = "cc-config.overview";
    CCPermissions["SMART_RESPONSES_VIEW"] = "cc-config.smart-responses";
    CCPermissions["SUPERVISOR_PAGE_VIEW"] = "cc-supervisor";
    CCPermissions["SUPERVISOR_WALLBOARD_VIEW"] = "cc-supervisor.wallboard";
    CCPermissions["SURVEYS_VIEW"] = "cc-config.surveys";
    CCPermissions["USERS_VIEW"] = "cc-config.users";
})(CCPermissions || (CCPermissions = {}));
//# sourceMappingURL=index.js.map